exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol {\r\n\tpadding-left: 16px;\r\n}\r\n\r\nol > li {\r\n\tmargin-top: 10px;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.link{\r\n\ttext-decoration: underline;\r\n\tcolor: #1bbbdf;\r\n\tcursor: pointer;\r\n}\r\n\r\n.main-title{\r\n\tfont-weight: bold;\r\n\tmargin: 0 0 20px;\r\n    display: block;\r\n\tfont: 500 20px/32px Roboto,\"Helvetica Neue\",sans-serif;\r\n}\r\n\r\n.mat-checkbox-checked.mat-accent .mat-checkbox-background {\r\n\tbackground-color: #41D78Ced !important;  \r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/components/cambiar-pass/cambiar-pass.component.css
// module id = ../../../../../src/app/modules/habilitar-cuenta/components/cambiar-pass/cambiar-pass.component.css
// module chunks = main